import { useInView } from 'react-intersection-observer';
import type { MenuItem, ReviewItem } from '@/types/shop';
import clsx from 'clsx';
import styles from './styles.module.scss';
import { useOrientation } from '@/hooks';
import ReviewMenuSlideHorizontal from './ReviewMenuSlideHorizontal';
import ReviewMenuSlideVertical from './ReviewMenuSlideVertical';
import { useConfigStore } from '@/stores';

type Props = {
    showReview?: boolean;
    reviewList?: ReviewItem[];
    menuList?: MenuItem[] | null;
};

export const MenuReview = ({ showReview = true, reviewList, menuList }: Props) => {
    const { isHorizontal } = useOrientation();
    const currentLanguage = useConfigStore((state) => state.config.ui.language);
    const { ref: firstRef, inView: isFirstFullyVisible } = useInView({
        threshold: 1,
    });

    const { ref: lastRef, inView: isLastFullyVisible } = useInView({
        threshold: 1,
    });

    return (
        <div className={styles['review-menu-slides']}>
            <div className={clsx({ [styles['fade-left']]: showReview }, { [styles['fade-left--visible']]: !isFirstFullyVisible })} />
            <div className={clsx({ [styles['fade-right']]: showReview }, { [styles['fade-right--visible']]: !isLastFullyVisible && currentLanguage === 'ko' })} />
            <div
                className={clsx(styles['review-menu-slides__content'], 'scrollbar-hide relative max-w-[100vw] overflow-x-auto', {
                    [styles['review-menu-slides__content--no-review']]: !showReview,
                })}
            >
                {isHorizontal ? (
                    <ReviewMenuSlideHorizontal menuList={menuList} reviewList={reviewList} showReview={showReview} firstRef={firstRef} lastRef={lastRef} />
                ) : (
                    <ReviewMenuSlideVertical menuList={menuList} reviewList={reviewList} showReview={showReview} firstRef={firstRef} lastRef={lastRef} />
                )}
            </div>
        </div>
    );
};
